var autocompleteId = 0;
export function generateAutocompleteId() {
  return "autocomplete-".concat(autocompleteId++);
}


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-shared/dist/esm/generateAutocompleteId.js
// module id = 64
// module chunks = 0